/**
 * StatsCard Component
 *
 * A reusable statistics display card with gradient backgrounds.
 * Used in AirdropHistory and ReverseAirdrop for displaying metrics.
 */

import React from "react";
import { statsCardStyles, gradients } from "../styles";

const StatsCard = ({ value, label, variant = "primary" }) => {
  const backgroundMap = {
    primary: gradients.primary,
    accent: gradients.accent,
    success: gradients.success,
    danger: gradients.danger,
    info: gradients.info,
    gray: gradients.gray,
  };

  return (
    <div
      style={{
        ...statsCardStyles.card,
        background: backgroundMap[variant] || backgroundMap.primary,
      }}
    >
      <span style={statsCardStyles.value}>{value}</span>
      <span style={statsCardStyles.label}>{label}</span>
    </div>
  );
};

/**
 * StatsContainer Component
 *
 * Container for multiple StatsCard components
 */
export const StatsContainer = ({ children }) => (
  <div style={statsCardStyles.container}>{children}</div>
);

export default StatsCard;
